/* eslint-disable no-param-reassign */
import { updateProgressStep, updateCurrentView } from './utils/ProgressStep';
import { getSession, setSession, getLTEUpgrade } from './components/common/Helpers/index';
import history from './utils/history';

export const redirectTo = (modelRootPath, hist) => {
  // return <Redirect to={ modelRootPath + '.html' }/>;
  // return push(modelRootPath + '.html');
  // return <Redirect to={{ pathname: modelRootPath + '.html' }} />
  if (!hist) hist = history;
  if (hist.location.pathname.indexOf('covid') > -1) {
    hist.location.pathname = hist.location.pathname.replace('/setup', '');
  }
  return hist.push(modelRootPath);
};

export const goToProcessStep = (process, hist = null, isEdit, isNoSlotsAvailable, isPlansEdit, isSetupEdit) => {
  // debugger;
  const orderSubmitted = getSession('OrderSubmitted');
  const isEditFromCart = getSession('isEditFromCart');
  // const isEditPlan = getSession('isPlansEdit');
  // const noSlotsAvailable = getSession('isNoSlotsAvailable');
  const pathArr = hist.location.pathname.split('/');
  const hashPath = hist.location.hash;
  const pathName = orderSubmitted !== 'Y' ? pathArr[pathArr.length - 1].split('.')[0] : 'confirmation';
  if (hashPath.indexOf('sessionExpiry') > -1) {
    window.sessionStorage.clear();
    window.localStorage.clear();
    window.location.href = '/';
    return;
  }
  if (isEditFromCart === 'Y') {
    setSession('isEditFromCart', 'N');
  }
  // if (noSlotsAvailable === 'Y') {
  //   setSession('isNoSlotsAvailable', 'N');
  // }
  if (isEdit) {
    setSession('isEditFromCart', 'Y');
    updateProgressStep(process.editStep, true);
    redirectTo(process.editPage, hist);
  } else if (isPlansEdit) {
    setSession('isPlansEdit', 'Y');
    updateProgressStep(process.editPlansStep, true);
    window.location.href = process.editPlansPage;
    // redirectTo(process.editPlansPage, hist);
  } else if (isSetupEdit) {
    setSession('isSetupEdit', 'Y');
    updateProgressStep(process.previousStep, true);
    redirectTo(process.editSetupPage, hist);
  } else if (isNoSlotsAvailable) {
    setSession('isNoSlotsAvailable', 'Y');
    updateProgressStep(process.noSLotsStep, true);
    redirectTo(process.noSLots, hist);
  } else if (orderSubmitted !== 'Y' && process) {
    const nextStep = getLTEUpgrade() && process.nextStep === 'Addons' ? 'Cart' : process.nextStep;
    const nextViewPage = getLTEUpgrade() && process.nextStep === 'Addons' ? 'cart.html' : process.nextViewPage;
    updateProgressStep(nextStep, true);
    redirectTo(nextViewPage, hist);
  } else if (orderSubmitted === 'Y') {
    redirectTo(`${String?.protoType?.toLowercase(process.currentStep)}.html`, hist);
  } else {
    updateCurrentView(pathName, hist);
  }
};

export const updateProcessOnBrowserAction = (location) => {
  const orderSubmitted = getSession('OrderSubmitted');
  const pathArr = location.pathname.split('/');
  const pathName = orderSubmitted !== 'Y' ? pathArr[pathArr.length - 1].split('.')[0] : 'confirmation';
  if (pathName) {
    updateProgressStep(pathName, true);
  }
};
